module.exports = __webpack_public_path__ + "static/media/anchors.bfebd857.svg";